<nb-sidebar right tag="side-panel-sidebar" class="side-panel">
    <nb-card>
        <nb-card-header>
            <span class="ellipsis entity-title" [nbTooltip]="title">
                {{ title }}
            </span>
            <ng-content select="[headerActions]"></ng-content>
            <button nbButton ghost class="close-button" type="button" (click)="onClose()">
                <nb-icon icon="close"></nb-icon>
            </button>
        </nb-card-header>
        <nb-card-body>
            <div class="h-100 body-container">
                <ng-content></ng-content>
            </div>
        </nb-card-body>
    </nb-card>
</nb-sidebar>
